<template>
  <v-container pa-0>
    <v-row class="align-end">
      <v-col cols="12" lg="8">
        <v-text-field
          v-model="searchText"
          outlined
          large
          flat
          hide-details
          clearable
          prepend-inner-icon="mdi-magnify"
          clear-icon="mdi-close-circle-outline"
          :label="searchLabel"
          @input="search"
        />
      </v-col>

      <v-col cols="12" lg="4" class="pagination-container">
        <p>Strona:</p>

        <div class="pagination-content">
          <v-pagination
            v-model="page"
            role="navigation"
            aria-label="Nawigacja paginacyjna górna"
            color="primary"
            :total-visible="9"
            :length="pagesAmount"
            @input="changePage"
          />
        </div>
      </v-col>
    </v-row>

    <slot name="filters" />

    <slot />

    <v-row class="justify-center">
      <v-col cols="12" lg="4" class="pagination-container">
        <p>Strona:</p>

        <div class="pagination-content">
          <v-pagination
            v-model="page"
            role="navigation"
            aria-label="Nawigacja paginacyjna dolna"
            color="primary"
            :total-visible="9"
            :length="pagesAmount"
            @input="changePage"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { sharedConfig } from '@witkac/kartamiejska-shared';
import { tryParseInt } from '@witkac/utils/tryParseInt';

// @vuese
// Otoczka do list z paginacją i wyszukiwarką
export default {
  props: {
    // Label inputa z wyszukiwarką
    searchLabel: { type: String, default: 'Wyszukaj' },
    // Liczba elementów na stronę
    perPage: { type: Number, defalt: sharedConfig.onPage },
    // Całkowita liczba elementów
    total: { type: Number, required: true }
  },
  data() {
    return {
      searchText: this.$route.query.search || '',
      page: tryParseInt(this.$route.query.page) || 1,
      searchTimeout: undefined
    };
  },
  computed: {
    // Liczba stron
    pagesAmount() {
      return Math.ceil(this.total / this.perPage) || 1;
    }
  },
  watch: {
    '$route.query.page': {
      immediate: true,
      handler(value) {
        this.page = tryParseInt(value) || 1;
      }
    }
  },
  methods: {
    // Wyszukuje daną frazę
    search(search) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.$router.replace({ query: { ...this.$route.query, search, page: 1 } });
        this.page = 1;
      }, 500);
    },
    // Ustawia daną stronę
    changePage(page) {
      this.$router.replace({ query: { ...this.$route.query, page } });
    }
  }
};
</script>
